module.exports = __webpack_public_path__ + "img/address-icon.4cc531f0.png";